var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { InternMap } from "internmap";
import identity from "./identity.js";
export default function group(values) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return nest(values, identity, identity, keys);
}
export function groups(values) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return nest(values, Array.from, identity, keys);
}
function flatten(groups, keys) {
    for (var i = 1, n = keys.length; i < n; ++i) {
        groups = groups.flatMap(function (g) { return g.pop().map(function (_a) {
            var key = _a[0], value = _a[1];
            return __spreadArrays(g, [key, value]);
        }); });
    }
    return groups;
}
export function flatGroup(values) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return flatten(groups.apply(void 0, __spreadArrays([values], keys)), keys);
}
export function flatRollup(values, reduce) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    return flatten(rollups.apply(void 0, __spreadArrays([values, reduce], keys)), keys);
}
export function rollup(values, reduce) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    return nest(values, identity, reduce, keys);
}
export function rollups(values, reduce) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    return nest(values, Array.from, reduce, keys);
}
export function index(values) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return nest(values, identity, unique, keys);
}
export function indexes(values) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1)
        throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return (function regroup(values, i) {
        if (i >= keys.length)
            return reduce(values);
        var groups = new InternMap();
        var keyof = keys[i++];
        var index = -1;
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            var key = keyof(value, ++index, values);
            var group_1 = groups.get(key);
            if (group_1)
                group_1.push(value);
            else
                groups.set(key, [value]);
        }
        for (var _a = 0, groups_1 = groups; _a < groups_1.length; _a++) {
            var _b = groups_1[_a], key = _b[0], values_2 = _b[1];
            groups.set(key, regroup(values_2, i));
        }
        return map(groups);
    })(values, 0);
}
